import classNames from 'classnames/bind';

import styles from './Slide.module.scss';
// import LinkButton from '../../../components/linkButton';

const cx = classNames.bind(styles);

const Slide = ({ data }) => {
  const getImage = (location) => {
    if (location === 'left') {
      switch (data.color) {
        case 'red':
          return require('../../../asset/images/home/red-left.png');
        case 'pink':
          return require('../../../asset/images/home/pink-left.png');
        case 'green':
          return require('../../../asset/images/home/green-left.png');
        case 'blue':
          return require('../../../asset/images/home/blue-left.png');
        default:
          break;
      }
    }

    if (location === 'right') {
      switch (data.color) {
        case 'red':
          return require('../../../asset/images/home/red-right.png');
        case 'pink':
          return require('../../../asset/images/home/pink-right.png');
        case 'green':
          return require('../../../asset/images/home/green-right.png');
        case 'blue':
          return require('../../../asset/images/home/blue-right.png');
        default:
          break;
      }
    }
  };

  return (
    <div className={cx('container')}>
      <h1 className={cx('line', data.color)}>{data.line}</h1>
      <div className={cx('wrapper')}>
        <img className={cx('image', 'left', data.color)} src={getImage('left')} alt={data.title} draggable={false} />
        <h2 className={cx('title', data.color)}>{data.title}</h2>
        <img className={cx('image', 'right', data.color)} src={getImage('right')} alt={data.title} draggable={false} />
      </div>
      {/* <div className={cx('info')}>
        <h3 className={cx('name')}>{data.name}</h3>
        <p className={cx('desc')}>{data.desc}</p>
      </div> */}
      {/* <LinkButton title="SHOW DETAIL" link={data.uri} color={data.title} /> */}
    </div>
  );
};

export default Slide;
